import { ip } from './ip'

export default function appFetch(url, options) {
	if (localStorage.getItem('token')) {
		options.headers = { ...options.headers, 'Authorization': `${localStorage.getItem('token')}` }
	}

	if (localStorage.getItem('AspiranteToken')) {
		options.headers = { ...options.headers, 'Authorization': `${localStorage.getItem('AspiranteToken')}` }
	}

	return new Promise((resolve, reject) => {
			fetch(ip + url, options)
				.then(response => {
					if (!response.ok) {
						if (response.status === 700) {
							return resolve(response)
						} else {
							return Promise.reject({ status: response.status })
						}
					}
						return response.json();
					
				}).then(response => {
					resolve(response)

				}).catch(error => {
					reject(error)
				})
	})

}
